export const hostingFaqs = [
  {
    question: "Qual plano de hospedagem devo escolher?",
    answer:
      "Depende do momento e da necessidade do seu projeto. Fale com um especialista para avaliarmos juntos a estrutura ideal para o seu negócio.",
  },
  {
    question: "Os recursos dos planos são fixos?",
    answer:
      "Os planos servem como referência. Os recursos podem ser configurados e ajustados conforme a necessidade da sua empresa.",
  },
  {
    question: "Posso migrar o meu site para a NXHOST?",
    answer:
      "Sim. Nossa equipe auxilia na migração do seu projeto, seguindo os passos necessários para manter tudo funcionando durante a transição.",
  },
  {
    question: "A hospedagem inclui e-mail profissional?",
    answer:
      "Sim. Os planos incluem e-mail profissional com o domínio da sua empresa para uma comunicação mais confiável.",
  },
  {
    question: "Como funciona o suporte?",
    answer:
      "Oferecemos atendimento próximo para ajudar quando você precisar. Fale com um especialista para conhecer as condições atuais de atendimento.",
  },
  {
    question: "Preciso de um plano maior para loja virtual?",
    answer:
      "Projetos como lojas virtuais e sistemas tendem a exigir mais recursos. Fale com a nossa equipe para indicarmos a melhor estrutura para o seu caso.",
  },
];

export const detailedPlans = [
  {
    name: "Profissional",
    audience: "Para sites institucionais e pequenos negócios.",
    price: "50",
    url: "https://nxhost.com.br/cliente/store/hospedagem-de-sites/profissional",
    badge: "",
    highlighted: false,
    summary: "Uma estrutura estável para colocar a sua empresa online com profissionalismo.",
    features: [
      "Hospedagem para sites institucionais",
      "E-mail profissional no seu domínio",
      "Certificado SSL",
      "Backups periódicos",
      "Painel de controle",
      "Suporte especializado",
    ],
  },
  {
    name: "Empresarial",
    audience: "Para empresas em crescimento.",
    price: "80",
    url: "https://nxhost.com.br/cliente/store/hospedagem-de-sites/hospedagens-empresarial",
    badge: "Mais escolhido",
    highlighted: true,
    summary: "Mais estrutura e prioridade para o seu projeto continuar crescendo.",
    features: [
      "Tudo do plano Profissional",
      "Estrutura preparada para mais acessos",
      "Backups com maior frequência",
      "Prioridade no atendimento",
    ],
  },
  {
    name: "Premium",
    audience: "Para projetos que precisam de mais recursos.",
    price: "120",
    url: "https://nxhost.com.br/cliente/store/hospedagem-de-sites/hospedagem-premium",
    badge: "",
    highlighted: false,
    summary: "Recursos ampliados para lojas virtuais, sistemas e projetos maiores.",
    features: [
      "Tudo do plano Empresarial",
      "Recursos ampliados para projetos maiores",
      "Estrutura para lojas virtuais e sistemas",
      "Suporte prioritário",
    ],
  },
  {
    name: "Semi Dedicada",
    audience: "Para projetos com maior demanda.",
    price: "180",
    url: "https://nxhost.com.br/cliente/store/hospedagem-de-sites/hospedagem-dedicada",
    badge: "",
    highlighted: false,
    summary: "Estrutura com recursos dedicados para quem precisa de mais capacidade.",
    features: [
      "Tudo do plano Premium",
      "Recursos dedicados",
      "Estrutura para alta demanda",
      "Atendimento dedicado",
    ],
  },
];

export const includedFeatures = [
  {
    icon: "ri-dashboard-3-line",
    title: "Painel de controle",
    description: "Gerencie sites, e-mails e arquivos de forma simples e centralizada.",
  },
  {
    icon: "ri-mail-send-line",
    title: "E-mail profissional",
    description: "Comunicação empresarial com o domínio da sua empresa.",
  },
  {
    icon: "ri-lock-2-line",
    title: "Certificado SSL",
    description: "Conexões seguras para proteger visitantes e informações.",
  },
  {
    icon: "ri-database-2-line",
    title: "Backups",
    description: "Estrutura preparada para proteção adicional das informações.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Segurança",
    description: "Recursos de proteção para os seus projetos digitais.",
  },
  {
    icon: "ri-customer-service-2-line",
    title: "Suporte especializado",
    description: "Atendimento próximo para ajudar quando você precisar.",
  },
];

export const planComparison = {
  plans: ["Profissional", "Empresarial", "Premium", "Semi Dedicada"],
  rows: [
    { feature: "Hospedagem de sites", values: [true, true, true, true] },
    { feature: "E-mail profissional", values: [true, true, true, true] },
    { feature: "Certificado SSL", values: [true, true, true, true] },
    { feature: "Backups", values: [true, true, true, true] },
    { feature: "Painel de controle", values: [true, true, true, true] },
    { feature: "Prioridade no atendimento", values: [false, true, true, true] },
    { feature: "Recursos ampliados", values: [false, false, true, true] },
    { feature: "Recursos dedicados", values: [false, false, false, true] },
  ],
};

export const migrationSteps = [
  {
    icon: "ri-chat-3-line",
    title: "Fale com um especialista",
    description: "Conte o que você precisa e onde o seu site ou sistema está hoje.",
  },
  {
    icon: "ri-search-eye-line",
    title: "Avaliamos a sua estrutura",
    description: "Analisamos o seu projeto para indicar a solução mais adequada.",
  },
  {
    icon: "ri-exchange-2-line",
    title: "Cuidamos da migração",
    description: "Movemos a sua estrutura com cuidado para manter tudo no ar.",
  },
  {
    icon: "ri-checkbox-circle-line",
    title: "Acompanhamos os primeiros dias",
    description: "Seguimos por perto para garantir uma transição tranquila.",
  },
];